import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import PreviewIcon from "@mui/icons-material/Preview";
import {
  Avatar,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { baseUrl } from "../../utils/baseUrl";
import { useGetAllItemsQuery } from "../../Slices/roomNateApis";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  height: "90%",
  overflowY: "auto",
  width: { xs: "90%", md: "650px" },
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function ViewModal({
  items,
  connectionPointsOptionsData,
  zonesData,
}) {
  const { data: itemsO } = useGetAllItemsQuery({itemType:1});
  
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  function getLabel(value, obj) {
    for (let i = 0; i < obj?.length; i++) {
      if (obj[i].value === value) {
        return obj[i].label;
      }
    }
    return null;
  }

  return (
    <>
      <Tooltip title="Preview">
        <IconButton color="primary" onClick={handleOpen}>
          <PreviewIcon />
        </IconButton>
      </Tooltip>
      
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box position="fixed" top={10} right={0}>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>

          <Stack
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box>
              <Typography variant="h6" mb={1}>
                Front View Image
              </Typography>
              {items?.frontViewImage && (
                <img
                  src={`${baseUrl}/g${items?.frontViewImage}`}
                  style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "cover",
                  }}
                  alt="asdasd"
                  className="rounded"
                />
              )}
            </Box>

            <Box>
              <Typography variant="h6" mb={1}>
                Top View Image
              </Typography>
              {items?.topViewImage && (
                <img
                  src={`${baseUrl}/g${items?.topViewImage}`}
                  style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "cover",
                  }}
                  alt="asdasd"
                  className="rounded"
                />
              )}
            </Box>
          </Stack>

          {items?.name && (
            <Stack my={1}>
              <Typography variant="h6">
                Name:{" "}
                <Typography variant="h6" component={"span"} fontWeight={400}>
                  {items?.name}
                </Typography>
              </Typography>
            </Stack>
          )}

          {items?.likelihood && (
            <Stack my={1}>
              <Typography variant="h6">
                Likelihood:{" "}
                <Typography variant="h6" component={"span"} fontWeight={400}>
                  {items?.likelihood}
                </Typography>
              </Typography>
            </Stack>
          )}

          {items?.zones && (
            <Stack my={1}>
              <Typography variant="h6">Zone:</Typography>
              {items?.zones?.map((item, index) => {
                return (
                  <div key={index}>
                    {zonesData?.find((item1) => item1?.value === item)?.label}
                  </div>
                );
              })}
            </Stack>
          )}

          {items?.layoutItems.length >= 1 && (
            <TableContainer component={Paper}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  py: 2,
                  px: 2,
                }}
              >
                <Typography variant="h6" component={"h6"} flexGrow={1}>
                  Layout Items
                </Typography>
              </Box>
              <Table sx={{ minWidth: 400 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Image View</TableCell>
                    <TableCell align="center">Name</TableCell>
                    <TableCell align="center">Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items?.layoutItems?.map((row, index) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <Avatar
                            alt="Remy Sharp"
                            src={`${baseUrl}/g${itemsO?.items?.find((item=> item?._id == row._id))?.frontViewImage}`}
                            variant="square"
                          />
                        </TableCell>
                        <TableCell align="center">{itemsO?.items?.find((item=> item?._id == row._id))?.name}</TableCell>
                        <TableCell align="center">{row.capacity}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {items?.clearanceItems && items?.clearanceItems.length >= 1 && (
            <Stack my={1}>
              <Typography variant="h6">Clearance Item:</Typography>

              {items?.clearanceItems?.map((item, index) => {
                return (
                  <Typography key={index} component={"small"} fontWeight={400}>
                    {item.name}
                  </Typography>
                );
              })}
            </Stack>
          )}

          {items?.variants?.map((item, index) => {
            return (
              <Stack my={1} key={index}>
                <Typography variant="h6">Variant {index + 1} :</Typography>

                <Typography component="small" fontWeight={"500"}>
                  Name:{" "}
                  <Typography component={"small"} fontWeight={400}>
                    {item?.name}
                  </Typography>
                </Typography>

                <Typography component="small" fontWeight={"500"}>
                  Capacity:{" "}
                  <Typography component={"small"} fontWeight={400}>
                    {item?.capacity}
                  </Typography>
                </Typography>

                <Typography component="small" fontWeight={"500"}>
                  Priority:{" "}
                  <Typography component={"small"} fontWeight={400}>
                    {item?.priority}
                  </Typography>
                </Typography>

                <Typography component="small" fontWeight={"500"}>
                  Length:{" "}
                  <Typography component={"small"} fontWeight={400}>
                    {item?.length}
                  </Typography>
                </Typography>

                <Typography component="small" fontWeight={"500"}>
                  Width:{" "}
                  <Typography component={"small"} fontWeight={400}>
                    {item?.width}
                  </Typography>
                </Typography>

              </Stack>
            );
          })}

          {items?.wallAttachments && (
            <Stack my={1}>
              <Typography variant="h6">Wall Attachment Points</Typography>

              <Typography component="small" fontWeight={"500"}>
                North:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.north,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                East:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.east,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>
              <Typography component="small" fontWeight={"500"}>
                South:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.south,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                West:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.west,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                Center:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.center,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                Top:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.top,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                Bottom:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.bottom,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                South East:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.southeast,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                South West:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.southwest,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                North East:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.northeast,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                North West:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.northwest,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                Center point between center and east:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.cce,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>

              <Typography component="small" fontWeight={"500"}>
                Center point between center and west:{" "}
                <Typography component={"small"} fontWeight={400}>
                  {getLabel(
                    items?.wallAttachments?.ccw,
                    connectionPointsOptionsData
                  )}
                </Typography>
              </Typography>
            </Stack>
          )}
        </Box>
      </Modal>
    </>
  );
}
